var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.6@core-js/library/modules/_core.js
// module id = 29
// module chunks = 0 1